import { render } from "./IntroComponent.vue?vue&type=template&id=6f33b9fa&scoped=true"
import script from "./IntroComponent.vue?vue&type=script&lang=js"
export * from "./IntroComponent.vue?vue&type=script&lang=js"

import "./IntroComponent.vue?vue&type=style&index=0&id=6f33b9fa&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f33b9fa"]])

export default __exports__